import { ICompanyInfo } from "../../../site/feature-modules/welcome/models/welcome.models";

export class GetCompanyInfo {
    static readonly type = '[Company] GetAll';
}

export class AddCompanyInfo {
    static readonly type = '[Company] Add';

    constructor(public payload: ICompanyInfo) {
    }
}
